import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String, description: String }

  track(event) {
    const platform = event.currentTarget.dataset.platform
    
    // Analytics tracking (if needed)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'share', {
        'method': platform,
        'content_type': 'blog_post',
        'item_id': this.urlValue
      })
    }

    // For mobile sharing
    if (navigator.share && platform === 'native') {
      event.preventDefault()
      this.shareNative()
    }
  }

  async shareNative() {
    try {
      await navigator.share({
        title: this.titleValue,
        text: this.descriptionValue,
        url: this.urlValue
      })
    } catch (err) {
      console.log('Error sharing:', err)
    }
  }

  copyLink(event) {
    event.preventDefault()
    
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.urlValue).then(() => {
        this.showCopiedMessage()
      }).catch(() => {
        this.fallbackCopyTextToClipboard()
      })
    } else {
      this.fallbackCopyTextToClipboard()
    }
  }

  fallbackCopyTextToClipboard() {
    const textArea = document.createElement("textarea")
    textArea.value = this.urlValue
    textArea.style.top = "0"
    textArea.style.left = "0" 
    textArea.style.position = "fixed"

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      this.showCopiedMessage()
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
  }

  showCopiedMessage() {
    // Create temporary notification
    const notification = document.createElement('div')
    notification.textContent = 'Link copied to clipboard!'
    notification.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 transition-all duration-300'
    
    document.body.appendChild(notification)
    
    setTimeout(() => {
      notification.style.opacity = '0'
      notification.style.transform = 'translateY(-10px)'
      setTimeout(() => {
        document.body.removeChild(notification)
      }, 300)
    }, 2000)
  }
}